import ChaletIcon from '@mui/icons-material/Chalet';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LanguageIcon from '@mui/icons-material/Language';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import TtkList from './TtkList';

const AnchorTTK = ({ data }) => {
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Price:</b>&nbsp;<span>{data?.startingPrice}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Languages:</b>&nbsp;<TtkList data={data?.language} /></p>
                        </div>
                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p> <ChaletIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Types Of Event Cover:</b>&nbsp;<TtkList data={data?.eventTypeAnchor} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <RunningWithErrorsIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Duration:</b>&nbsp;<span>{data?.Duration}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Areas Of Services :</b>&nbsp;<TtkList data={data?.areaOfWork} /></p>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default AnchorTTK